import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWallet } from '@fortawesome/free-solid-svg-icons'
import { IconCashBanknoteFilled, IconCategoryFilled, IconChartPie2Filled } from '@tabler/icons-react'
import { InvoiceChart } from './Modules/InvoiceChart'
import { FinancialStatsOverview } from './Modules/FinancialStatsOverview'
import { FinanceCardWrapper } from './Modules/FinanceCardWrapper'
import { StatsData } from '../commonComponents/SalesStatsCard'
import { SuccessRateCard } from './Modules/SuccessRateCard'
import { DashboardCardWrapper } from '../commonComponents/DashboardCardWrapper'
import { RevenueByCategory } from './Modules/RevenueByCategory'
import { TopRevenueClients } from './Modules/TopRevenueClients'
import { ComparisonChart } from './Modules/ComparisonChart'
import { Col } from 'react-bootstrap'
import { PaymentMethodsChart } from './Modules/PaymentMethodsChart'

export const FinancialDashboard = () => {

    return (
        <div className='d-flex gap-4 flex-column mt-4'>
            <section className='w-100 d-flex gap-4' style={{ height: "" }} >
                <div className=' gap-4' style={{ display: "flex", flexDirection: "column", width: "60%" }}>
                    {/* card 1 & card 2  */}
                    <div className='d-flex gap-4' >
                        <StatsData
                            label={"Total Revenue"}
                            icon={<FontAwesomeIcon icon={faWallet}
                                size={"lg"}
                                style={{ color: 'white', }}
                            />}
                            percent={10.8}
                            value="108"
                            iconBg="#7539ff"
                            isCurrency={true} />
                        <FinanceCardWrapper
                            title={"Invoiced Amount"}
                            value={"12,468"}
                            percent={"82.2"}
                            icon={<IconCategoryFilled size={24} color='white' />}
                            iconBg={"#e04e17"}
                        />
                    </div>

                    {/* card 3 */}
                    <SuccessRateCard />

                    <div className='d-flex gap-4 w-100'>
                        <FinanceCardWrapper
                            title={"Collected"}
                            value={"10,622"}
                            percent={"82.2"}
                            icon={<IconChartPie2Filled size={24} color='white' />}
                            iconBg={"#0f9384"}
                        />
                        <StatsData
                            label="Net Profit"
                            icon={<IconCashBanknoteFilled size={24} color='white' />}
                            percent={12.1}
                            value="5000"
                            iconBg="#28ae60"
                            isCurrency={true}
                        />
                    </div>
                </div>

                <div className='d-flex flex-column gap-4 w-100' style={{}}>
                    {/* finance img div */}
                    <FinancialStatsOverview />
                    <InvoiceChart />
                </div>
            </section >

            <section className='row' style={{ height: "30rem" }}>
                <Col md={4}>
                    <TopRevenueClients />
                </Col>
                <Col md={8}>
                    <DashboardCardWrapper
                        headerText={"Activity Tracker"}
                        headerSubtext={"Activities from  quotations ,sales and invoices."}
                        componentClassname={"w-50 d-flex flex-stretch h-100"}
                    >
                    </DashboardCardWrapper>
                </Col>
            </section>

            <section className='d-flex gap-4' style={{}}>
                <ComparisonChart />
                <PaymentMethodsChart />
                <RevenueByCategory />
            </section>

        </div >
    )
}
